import { runtimeConfig } from '@/config/runtime-config'
import { createApiClient } from '@/lib/api/http-client'
import { getStoredToken } from '@/lib/auth/token-storage'

const apiClient = createApiClient({
  baseUrl: runtimeConfig.apiBaseUrl,
  getToken: () => getStoredToken('user'),
  portal: 'user',
})

/** 使用现有 Portal session 补签只发送到 `/oidc` 的短期 browser cookie。 */
export async function bootstrapOAuthBrowserSession() {
  await apiClient.request<{ code: 'success' }>('/app/idp/session', {
    credentials: 'include',
    method: 'POST',
  })
}
